export default __webpack_public_path__ + "static/legacy-teaser-d4e178e5fa6580c90da68191226c59c1.jpg";